/* eslint-disable */
import { get } from 'lodash';

// EA template ids are controlled through feature flag SCRN-340-el-assessment-template
// ONLY for documentation purposes:
export const EL_ASSESS_TEMPLATES = {
  STAGING: {
    V2: 'e648cd04-52df-4e54-b45a-b4468ba58886',
    V3: '3ef86ff4-5698-44f8-bd16-c2b7b8c19ffd',
    V4: '54a6b1c9-8d82-45b9-b44c-5050d98f2ec8',
  },
  NAAA: {
    V2: '52f9c652-b81d-4239-98fc-ea8c438fa05d',
    V3: 'ca2d1ad0-b1fd-4d30-a724-50805e3bd2f2',
    V4: '3c286874-c88a-4c08-a5c7-72227c5eb10e',
  },
  TRAINING: {
    V2: '4261a46d-3ff6-450e-a8a2-9f8d84f2bd9b',
    V3: '4483499e-ca19-483c-8809-74f5f1c662f5',
  },
  PRODUCTION: {
    V2: '5a7aa70e-4dc7-45de-841d-34bfee5bbfc6',
    V3: '11560335-bbd7-487d-8a52-99ac93ad6f69',
  },
};

const DEBUG_MODE = false;

const SURVEYJS_TYPES = {
  TEXT: 'text',
  RADIO: 'radiogroup',
  SELECT: 'dropdown',
  SELECT_MULTIPLE: 'dropdown-multiselect',
  HTML: 'html',
};

export const SURVEYJS_INPUT_TYPES = {
  DATE: 'date',
  NUMBER: 'number',
};

export const ELEMENT_DICTIONARY_V3 = {
  'qDateAttempt1': 'Date of Outreach 1:',
  'qModalityAttempt1': 'Modality of Outreach 1:',
  'qOutcomeAttempt1': 'Outcome of Outreach 1:',
  'qDateAttempt2': 'Date of Outreach 2:',
  'qModalityAttempt2': 'Modality of Outreach 2:',
  'qOutcomeAttempt2': 'Outcome of Outreach 2:',
  'qDateAttempt3': 'Date of Outreach 3:',
  'qModalityAttempt3': 'Modality of Outreach 3:',
  'qOutcomeAttempt3': 'Outcome of Outreach 3:',

  'qListAdditionalNameAndDOB': 'Please list name and DOB for each household member',
  'qAdditionalMedicaidMembers': 'Are there any additional Medicaid-enrolled individuals residing within your household?',
  'qConfirmAccurateInfo': 'Do you confirm that the information you provide during this assessment is accurate and complete to the best of your knowledge?',
  'qVerifyIdentity': 'Verify the member\'s identity using acceptable methods (e.g., government-issued ID, knowledge-based verification).',
  'qVerifyMedicaidEnrollment': 'Verify Medicaid enrollment status for both Fee-For-Service and Managed Care Members',
  'qVerifyMedicaidEnrollmentV3': 'Use ePACES to verify Medicaid enrollment status for both Fee-For-Service and Managed Care Members',
  'qMedicaidPlanType': 'What is the member\'s Medicaid plan type?',
  'qNYExcludedPopulation': 'Is the member part of an excluded population?',
  'qEnhancedPopulations': 'Enhanced Populations',
  'qClinicalCriteria': 'Clinical Criteria',
  'qAdditionalClinicalConditions': 'Additional Clinical Conditions',

  'qChronicConditionsVerification': 'Chronic Conditions - Verification Method',
  'qChronicConditionsProviderName': 'Chronic Conditions - Attesting Provider\'s Name',
  'qChronicConditionsProviderNPI': 'Chronic Conditions - Attesting Provider\'s NPI',
  'qChronicConditionsAttestationStored': 'Chronic Conditions - Attestation Form Received and Stored',

  'qAsthmaVerification': 'Uncontrolled Asthma - Verification Method',
  'qAsthmaProviderName': 'Uncontrolled Asthma - Attesting Provider\'s Name',
  'qAsthmaProviderNPI': 'Uncontrolled Asthma - Attesting Provider\'s NPI',
  'qAsthmaAttestationStored': 'Uncontrolled Asthma - Attestation Form Received and Stored',

  'qNutritionTherapyVerification': 'Require Enteral or Parenteral Nutrition Therapy - Verification Method',
  'qNutritionTherapyProviderName': 'Require Enteral or Parenteral Nutrition Therapy - Attesting Provider\'s Name',
  'qNutritionTherapyProviderNPI': 'Require Enteral or Parenteral Nutrition Therapy - Attesting Provider\'s NPI',
  'qNutritionTherapyAttestationStored': 'Require Enteral or Parenteral Nutrition Therapy - Attestation Form Received and Stored',

  'qHeatIllnessVerification': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit - Verification Method',
  'qHeatIllnessProviderName': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit - Attesting Provider\'s Name',
  'qHeatIllnessProviderNPI': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit - Attesting Provider\'s NPI',
  'qHeatIllnessAttestationStored': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit - Attestation Form Received and Stored',
  'qHeatIllnessAttestHome': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit - Member Attests Illness Occurred at Home',

  'qColdIllnessVerification': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit - Verification Method',
  'qColdIllnessProviderName': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit - Attesting Provider\'s Name',
  'qColdIllnessProviderNPI': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit - Attesting Provider\'s NPI',
  'qColdIllnessAttestationStored': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit - Attestation Form Received and Stored',
  'qColdIllnessAttestHome': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit - Member Attests this Occurred at Home',

  'qThermoregulationRiskVerification': 'At Risk of Thermoregulation Interference - Verification Method',
  'qThermoregulationRiskProviderName': 'At Risk of Thermoregulation Interference - Attesting Provider\'s Name',
  'qThermoregulationRiskProviderNPI': 'At Risk of Thermoregulation Interference - Attesting Provider\'s NPI',
  'qThermoregulationRiskAttestationStored': 'At Risk of Thermoregulation Interference - Attestation Form Received and Stored',


  'qConnectToServices': 'Would you like to be connected to services to address your needs?',
  'qDifficultyWalking': 'Does the Member have serious difficulty walking or climbing stairs (5 years old or older)?',
  'qDifficultyDressing': 'Does the Member have difficulty dressing or bathing (5 years old or older)?',
  'qRefrigerationBreastMilk': 'Do you require refrigeration for breast milk storage?',
  'qRefrigerationMedication': 'Do you have any medications that require refrigeration?',
  'qIncomeOtherSource': 'Do you have income from any other source outside of your job?',
  'qIncomeAnyOtherSource': 'Do you have income from any other source?',
  'qWhatOtherSourceIncome': 'What is your other source of income?',
  'qSNAPBenefits': 'Are you currently receiving help to buy groceries from the Supplemental Nutrition Assistance Program (SNAP), also known as food stamps, provided by New York State (NYS)?',
  'qReceiveTANF': 'Are you currently receiving help from the Temporary Assistance for Needy Families (TANF) program?',
  'qHousingSafetyConcerns': 'Do you have any concerns about the safety or quality of your current housing?',
  'qHousingConcerns': 'What concerns do you have about your housing? Select all that apply.',
  'qWorkInterest': 'What type of work are you interested in?',
  'qTransportationTroubleReasons': 'Please select all the reasons why you have trouble getting transportation:',
  'qFoodAssistance': 'Would you like assistance with your food needs?',
  'qHousingUtilitiesAssistance': 'Would you like assistance with your housing and utilities needs?',
  'qTransportationAssistance': 'Would you like assistance with your transportation needs?',
  'qFoodAssistanceType': 'What type of food assistance do you need? Select all that apply.',
  'qFoodPreparationAbility': 'Do you have the ability to store and prepare food, such as access to a refrigerator and stove?',
  'qCanPrepareMeals': 'Can you prepare and serve adequate meals either by yourself or with the help of a caregiver?',
  'qCaregiverPrepareMeals': 'Would you or a caregiver be able to prepare and serve adequate, nutritious meals if supplied with ingredients and instructions?',
  
  'qSelectScreening': "Select a previously conducted AHC screening to validate the member's Health-Related Social Needs (HRSNs).",
  'qMedicaidVerification': 'Medicaid High Utilizer - Verification Method',
  'qMedicaidVerificationAttestationForm': 'Medicaid High Utilizer - Attestation Form Received and Stored',
  'qMedicaidVerificationProviderName': 'Medicaid High Utilizer - Attesting Provider\'s Name',
  'qMedicaidVerificationProviderNPI': 'Medicaid High Utilizer - Attesting Provider\'s NPI',
  'qHealthHomeVerification': 'Enrolled in a NYS-designated Health Home Program - Verification Method',
  'qHealthHomeVerificationAttestationForm': 'Enrolled in a NYS-designated Health Home Program - Attestation Form Received and Stored',
  'qHealthHomeVerificationProviderName': 'Enrolled in a NYS-designated Health Home Program - Attesting Provider\'s Name',
  'qHealthHomeVerificationProviderNPI': 'Enrolled in a NYS-designated Health Home Program - Attesting Provider\'s NPI',
  'qAreYouPregnant': 'Are you currently pregnant?',
  'qPostpartumStartDate': 'Pregnant and Postpartum Person - Postpartum Start Date',
  
  'qChildcareHelp': 'Do you need help with childcare so you can work, attend school, or manage daily activities?',
  'qEstimatedDeliveryDate': 'Pregnant and Postpartum Person - Estimated Delivery Date',
  'qPregnancyVerificationMethod': 'Pregnant and Postpartum Person - Verification Method',
  'qPregnancyVerificationAttestationForm': 'Pregnant and Postpartum Person - Attestation Form Received and Stored',
  'qPregnancyVerificationProviderName': 'Pregnant and Postpartum Person - Attesting Provider\'s Name',
  'qPregnancyVerificationProviderNPI': 'Pregnant and Postpartum Person - Attesting Provider\'s NPI',
  'qPregnancyMemberAttestation': 'Pregnant and Postpartum Person - Member Attestation',
  'qChildVerificationMethod': 'High-Risk Child Under 18 Years Old - Verification Method',
  'qChildProviderName': 'High-Risk Child Under 18 Years Old - Attesting Provider\'s Name',
  'qChildProviderNPI': 'High-Risk Child Under 18 Years Old - Attesting Provider\'s NPI',
  'qChildAttestationStored': 'High-Risk Child Under 18 Years Old - Attestation Form Received and Stored',

  'qConditionIncarcerationVerification': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - RELEASE DATE Verification Method',
  'qConditionIncarcerationDocsStored': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Member Documentation Received and Stored',
   
  'qIncarcerationChronicConditionVerification': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - CHRONIC CONDITION Verification Method',
  'qIncarcerationChronicConditionAttestationForm': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attestation Form Received and Stored',
  'qIncarcerationChronicConditionProviderName': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attesting Provider\'s Name',
  'qIncarcerationChronicConditionProviderNPI': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attesting Provider\'s NPI',

  'qOtherPopulationsVerification': 'Other Eligible Population - Verification Method',
  'qOtherPopulationsVerificationProviderName': 'Other Eligible Population - Attesting Provider\'s Name',
  'qOtherPopulationsVerificationProviderNPI': 'Other Eligible Population - Attesting Provider\'s NPI',
  'qOtherPopulationsVerificationAttestationForm': 'Other Eligible Population - Attestation Form Received and Stored',
  'qChildNutritionVerification': 'High-Risk Children Under 18 Years Old Nutrition Only - Verification Method',
  'qChildNutritionVerificationProviderName': 'High-Risk Children Under 18 Years Old Nutrition Only - Attesting Provider\'s Name',
  'qChildNutritionVerificationProviderNPI': 'High-Risk Children Under 18 Years Old Nutrition Only - Attesting Provider\'s NPI',
  'qChildNutritionVerificationAttestationForm': 'High-Risk Children Under 18 Years Old Nutrition Only - Attestation Form Received and Stored',

  'qDisabilityIndepVerification': 'Physical disability that limits independence - Verification Method',
  'qDisabilityIndepAttestation': 'Physical disability that limits independence - Attestation Form Received and Stored',
  'qDisabilityIndepProviderName' : 'Physical disability that limits independence - Attesting Provider\'s Name',
  'qDisabilityIndepProviderNPI' : 'Physical disability that limits independence - Attesting Provider\'s NPI',

  'qHealthConditionEnvVerification': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Verification Method',
  'qHealthConditionEnvAttestation': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attestation Form Received and Stored',
  'qHealthConditionEnvProviderName': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attesting Providers Name',
  'qHealthConditionEnvProviderNPI': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attesting Providers NPI',

  'qPreSurgicalVerification': 'Requiring pre-surgical or procedure care - Verification Method',
  'qPreSurgicalAttestation': 'Requiring pre-surgical or procedure care - Attestation Form Received and Stored',
  'qPreSurgicalProviderName': 'Requiring pre-surgical or procedure care - Attesting Providers Name',
  'qPreSurgicalProviderNPI': 'Requiring pre-surgical or procedure care - Attesting Providers NPI',

  'qAcuteCareVerification': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Verification Method',
  'qAcuteCareAttestation': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attestation Form Received and Stored',
  'qAcuteCareProviderName': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attesting Providers Name',
  'qAcuteCareProviderNPI': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attesting Providers NPI',

  'qRefrigeratedMedsVerification': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Verification Method',
  'qRefrigeratedMedsAttestation': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attestation Form Received and Stored',
  'qRefrigeratedMedsProviderName': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attesting Providers Name',
  'qRefrigeratedMedsProviderNPI': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attesting Providers NPI',

  'qBreastMilkFridgeVerify': 'Requires refrigeration for breast milk - Verification Method',
  'qBreastMilkFridgeMemberAttestation': 'Requires refrigeration for breast milk - Member Attests',

  'qTransportationAccess': 'Do you have difficulty accessing transportation when you need it?',
  'qTransportationEffect': 'How does not having transportation affect you?',
  'qTransportationHelp': 'What kind of transportation help do you need? Please select all that apply:',
  'qTransportationServicesReceived': 'Do you already receive any transportation services?',
  'qTransportationServicesDescription': 'Please describe the transportation services you currently receive:',
  'qNutritionalCounseling': 'Are you currently receiving nutritional counseling or education provided through a New York State (NYS) social services program?',
  'qWICProgram': 'Are you or your children currently participating in the Women, Infants, and Children (WIC) program provided by New York State (NYS)?',
  'qHomeDeliveredMeals': 'Are you currently receiving home-delivered meals or food services through a New York State (NYS) social services program?',
  'qLivingSituation': 'Which best describes your current living situation?',
  'qHousingIssues': 'What specific housing issues are you experiencing? Select all that apply.',

  'qCareRecoveryNeed': 'Do you currently need care to recover from an illness or injury, prepare for a surgery or procedure, or transition out of a hospital or other facility?',
  'qHospitalRisk': 'Are you at risk of needing to go back to the hospital or emergency room if you don\'t get this care?',
  'qHousingProvider': 'Are you currently working with a housing provider or program?',
  'qHealthyHomesProgram': 'Do you participate in the Healthy Homes Program or any similar program provided by New York State (NYS) to address home environmental health hazards?',
  'qHousingWaitlists': 'Are you on any housing waitlists (e.g., HUD, Section 8, local housing authority, or other voucher programs) or receive a rental subsidy?',
  'qUtilitiesIssues': 'Are you experiencing any issues with your utilities?',
  'qUtilitiesIssuesTypes': 'Which of the following utilities issues are you experiencing?',
  'qUtilitiesAssistanceType': 'What type of utilities assistance do you need? Select all that apply.',
  'qUtilitiesProgramsReceived': 'Do you currently receive any utilities assistance programs?',
  'qUtilitiesProgramsDescription': 'Please specify the utilities assistance programs that you currently receive:',
  'qEmploymentSituation': 'Which of the following best describes your current employment situation?',

  'qServiceDuplicationCheck': 'NYS Service Duplication Check',
  'qNavigatorNotes': 'Navigator Notes:',
  'qOtherPrograms': 'Are there any other programs or services you\'re currently using that provide help with housing, food, healthcare, or other daily needs?',
  'qAdditionalPrograms': 'Additional Programs and Services:',
};

export const ELEMENT_DICTIONARY = {
  'qDateAttempt1': 'Date of Outreach 1:',
  'qModalityAttempt1': 'Modality of Outreach 1:',
  'qOutcomeAttempt1': 'Outcome of Outreach 1:',
  'qDateAttempt2': 'Date of Outreach 2:',
  'qModalityAttempt2': 'Modality of Outreach 2:',
  'qOutcomeAttempt2': 'Outcome of Outreach 2:',
  'qDateAttempt3': 'Date of Outreach 3:',
  'qModalityAttempt3': 'Modality of Outreach 3:',
  'qOutcomeAttempt3': 'Outcome of Outreach 3:',

  'qListAdditionalNameAndDOB': 'Please list name and DOB for each eligible Medicaid enrolled household member',
  'qAreYouCurrentlyEmployed': 'Are you currently employed?',
  // 'qAdditionalMedicaidMembers': 'Are there any additional Medicaid-enrolled individuals residing within your household?',
  'qImmediateFamily': 'How many immediate family members are in your household (i.e. parent, guardian, spouse, child)?',
  'qImmediateFamilyMedicaid': 'How many immediate family members in your household are medicaid-enrolled (i.e. parent, guardian, spouse, child)?',
  'qConfirmAccurateInfo': 'Do you confirm that the information you provide during this assessment is accurate and complete to the best of your knowledge?',
  'qVerifyIdentity': 'Verify the member\'s identity using acceptable methods (e.g., government-issued ID, knowledge-based verification).',
  'qVerifyMedicaidEnrollment': 'Verify Medicaid enrollment status for both Fee-For-Service and Managed Care Members',
  'qVerifyMedicaidEnrollmentV3': 'Use ePACES to verify Medicaid enrollment status for both Fee-For-Service and Managed Care Members',
  'qMedicaidPlanType': 'What is the member\'s Medicaid plan type?', // deprecated in V5
  'qNYExcludedPopulation': 'Is the member part of an excluded population?',
  'qEnhancedPopulations': 'Enhanced Populations',
  'qClinicalCriteria': 'Clinical Criteria',
  'qAdditionalClinicalConditions': 'Additional Clinical Conditions',

  'qChronicConditionsVerification': 'Chronic Conditions - Verification Method',
  'qChronicConditionsProviderName': 'Chronic Conditions - Attesting Provider\'s Name',
  'qChronicConditionsProviderNPI': 'Chronic Conditions - Attesting Provider\'s NPI',
  'qChronicConditionsAttestationStored': 'Chronic Conditions - Attestation Form Received and Stored',

  'qAsthmaVerification': 'Uncontrolled Asthma - Verification Method',
  'qAsthmaProviderName': 'Uncontrolled Asthma - Attesting Provider\'s Name',
  'qAsthmaProviderNPI': 'Uncontrolled Asthma - Attesting Provider\'s NPI',
  'qAsthmaAttestationStored': 'Uncontrolled Asthma - Attestation Form Received and Stored',

  'qNutritionTherapyVerification': 'Enteral or Parenteral Nutrition Therapy - Verification Method',
  'qNutritionTherapyProviderName': 'Enteral or Parenteral Nutrition Therapy - Attesting Provider\'s Name',
  'qNutritionTherapyProviderNPI': 'Enteral or Parenteral Nutrition Therapy - Attesting Provider\'s NPI',
  'qNutritionTherapyAttestationStored': 'Enteral or Parenteral Nutrition Therapy - Attestation Form Received and Stored',

  'qHeatIllnessVerification': 'Heat-Related Illness Requiring ER or UC Visit - Verification Method',
  'qHeatIllnessProviderName': 'Heat-Related Illness Requiring ER or UC Visit - Attesting Provider\'s Name',
  'qHeatIllnessProviderNPI': 'Heat-Related Illness Requiring ER or UC Visit - Attesting Provider\'s NPI',
  'qHeatIllnessAttestationStored': 'Heat-Related Illness Requiring ER or UC Visit - Attestation Form Received and Stored',
  'qHeatIllnessAttestHome': 'Heat-Related Illness Requiring ER or UC Visit - MEMBER ATTESTS Illness Occurred at Home',

  'qColdIllnessVerification': 'Cold-Related Illness Requiring ER or UC Visit - Verification Method',
  'qColdIllnessProviderName': 'Cold-Related Illness Requiring ER or UC Visit - Attesting Provider\'s Name',
  'qColdIllnessProviderNPI': 'Cold-Related Illness Requiring ER or UC Visit - Attesting Provider\'s NPI',
  'qColdIllnessAttestationStored': 'Cold-Related Illness Requiring ER or UC Visit - Attestation Form Received and Stored',
  'qColdIllnessAttestHome': 'Cold-Related Illness Requiring ER or UC Visit - MEMBER ATTESTS this Occurred at Home',

  'qThermoregulationRiskVerification': 'Risk of Thermoregulation Interference - Verification Method',
  'qThermoregulationRiskProviderName': 'Risk of Thermoregulation Interference - Attesting Provider\'s Name',
  'qThermoregulationRiskProviderNPI': 'Risk of Thermoregulation Interference - Attesting Provider\'s NPI',
  'qThermoregulationRiskAttestationStored': 'Risk of Thermoregulation Interference - Attestation Form Received and Stored',


  'qConnectToServices': 'Would you like to be connected to services to address your needs?',
  'qDifficultyWalking': 'Does the Member have serious difficulty walking or climbing stairs (5 years old or older)?',
  'qDifficultyDressing': 'Does the Member have difficulty dressing or bathing (5 years old or older)?',
  'qRefrigerationBreastMilk': 'Do you require refrigeration for breast milk storage?',
  'qRefrigerationMedication': 'Do you have any medications that require refrigeration?',
  'qIncomeOtherSource': 'Do you have income from any other source outside of your job?',
  'qIncomeAnySource': 'Do you have income from any source?',
  'qWhatOtherSourceIncome': 'What is your other source of income?',
  'qSchoolTrainingHelp': 'Do you want help with school or training? For example, starting or completing job training or getting a high school diploma, GED or equivalent',
  'qSNAPBenefits': 'Are you currently receiving help to buy groceries from the Supplemental Nutrition Assistance Program (SNAP), also known as food stamps, provided by New York State (NYS)?',
  'qReceiveTANF': 'Are you currently receiving help from the Temporary Assistance for Needy Families (TANF) program?',
  'qHousingSafetyConcerns': 'Do you have any concerns about the safety or quality of your current housing?',
  'qHousingConcerns': 'What concerns do you have about your housing? Select all that apply.',
  'qWorkInterest': 'What type of work are you interested in?',
  'qTransportationTroubleReasons': 'Please select all the reasons why you have trouble getting transportation:',
  'qTypesOfActivitiesTransportation': 'What types of activities do you need transportation for?',
  'qFoodAssistance': 'Would you like assistance with your food needs?',
  'qHousingUtilitiesAssistance': 'Would you like assistance with your housing and utilities needs?',
  'qTransportationAssistance': 'Would you like assistance with your transportation needs?',
  'qFoodAssistanceType': 'What type of food assistance do you need? Select all that apply.',
  'qFoodPreparationAbility': 'Do you have the ability to store and prepare food, such as access to a refrigerator and stove?',
  'qDoYouHaveCookingSupplies': 'Do you have cooking supplies such as pots, pans, utensils, plates, etc?',
  'qDoYouHaveDietaryRestrictions': 'Do you have any dietary restrictions or food allergies?',
  'qHowManyPeopleNeedFoodAssistance': 'How many people in your household need food assistance?',
  'qCanPrepareMeals': 'Can you prepare and serve adequate meals either by yourself or with the help of a caregiver?',
  'qCaregiverPrepareMeals': 'Would you or a caregiver be able to prepare and serve adequate, nutritious meals if supplied with ingredients and instructions?',
  
  'qSelectScreening': "Select a previously conducted AHC screening to validate the member's Health-Related Social Needs (HRSNs).",
  'qMedicaidVerification': 'Medicaid High Utilizer - Verification Method',
  'qMedicaidVerificationAttestationForm': 'Medicaid High Utilizer - Attestation Form Received and Stored',
  'qMedicaidVerificationProviderName': 'Medicaid High Utilizer - Attesting Provider\'s Name',
  'qMedicaidVerificationProviderNPI': 'Medicaid High Utilizer - Attesting Provider\'s NPI',
  'qHealthHomeVerification': 'Enrolled in a NYS Health Home - Verification Method',
  'qHealthHomeVerificationAttestationForm': 'Enrolled in a NYS Health Home - Attestation Form Received and Stored',
  'qHealthHomeVerificationProviderName': 'Enrolled in a NYS Health Home - Attesting Provider\'s Name',
  'qHealthHomeVerificationProviderNPI': 'Enrolled in a NYS Health Home - Attesting Provider\'s NPI',
  'qAreYouPregnant': 'Are you currently pregnant?',
  'qPostpartumStartDate': 'Pregnant and Postpartum Person - Postpartum Start Date',
  
  'qChildcareHelp': 'Do you need help with childcare so you can work, attend school, or manage daily activities?',
  'qEstimatedDeliveryDate': 'Pregnant and Postpartum Person - Estimated Delivery Date',
  'qPregnancyVerificationMethod': 'Pregnant and Postpartum Person - Verification Method',
  'qPregnancyVerificationAttestationForm': 'Pregnant and Postpartum Person - Attestation Form Received and Stored',
  'qPregnancyVerificationProviderName': 'Pregnant and Postpartum Person - Attesting Provider\'s Name',
  'qPregnancyVerificationProviderNPI': 'Pregnant and Postpartum Person - Attesting Provider\'s NPI',
  'qPregnancyMemberAttestation': 'Pregnant and Postpartum Person - Member Attestation',
  'qChildVerificationMethod': 'High-Risk Child Under 18 Years Old - Verification Method',
  'qChildProviderName': 'High-Risk Child Under 18 Years Old - Attesting Provider\'s Name',
  'qChildProviderNPI': 'High-Risk Child Under 18 Years Old - Attesting Provider\'s NPI',
  'qChildAttestationStored': 'High-Risk Child Under 18 Years Old - Attestation Form Received and Stored',

  'qConditionIncarcerationVerification': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - RELEASE DATE Verification Method',
  'qConditionIncarcerationDocsStored': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Member Documentation Received and Stored',
   
  'qIncarcerationChronicConditionVerification': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - CHRONIC CONDITION Verification Method',
  'qIncarcerationChronicConditionAttestationForm': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attestation Form Received and Stored',
  'qIncarcerationChronicConditionProviderName': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attesting Provider\'s Name',
  'qIncarcerationChronicConditionProviderNPI': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days - Attesting Provider\'s NPI',

  'qIntellectualDisabilitiesVerification': 'Individuals with Intellectual and Developmental Disabilities (IDD) Population - Verification Method',
  'qIntellectualDisabilitiesAttestation': 'Individuals with Intellectual and Developmental Disabilities (IDD) Population - Attestation Form Received and Stored',
  'qIntellectualDisabilitiesProviderName': 'Individuals with Intellectual and Developmental Disabilities (IDD) Population - Attesting Provider\'s Name',
  'qIntellectualDisabilitiesProviderNPI': 'Individuals with Intellectual and Developmental Disabilities (IDD) Population - Attesting Provider\'s NPI',

  'qOtherPopulationsVerification': 'Other Eligible Population - Verification Method',
  'qOtherPopulationsVerificationProviderName': 'Other Eligible Population - Attesting Provider\'s Name',
  'qOtherPopulationsVerificationProviderNPI': 'Other Eligible Population - Attesting Provider\'s NPI',
  'qOtherPopulationsVerificationAttestationForm': 'Other Eligible Population - Attestation Form Received and Stored',
  'qChildNutritionVerification': 'High-Risk Children Under 18 Years Old Nutrition Only - Verification Method',
  'qChildNutritionVerificationProviderName': 'High-Risk Children Under 18 Years Old Nutrition Only - Attesting Provider\'s Name',
  'qChildNutritionVerificationProviderNPI': 'High-Risk Children Under 18 Years Old Nutrition Only - Attesting Provider\'s NPI',
  'qChildNutritionVerificationAttestationForm': 'High-Risk Children Under 18 Years Old Nutrition Only - Attestation Form Received and Stored',

  'qDisabilityIndepVerification': 'Physical disability that limits independence - Verification Method',
  'qDisabilityIndepAttestation': 'Physical disability that limits independence - Attestation Form Received and Stored',
  'qDisabilityIndepProviderName' : 'Physical disability that limits independence - Attesting Provider\'s Name',
  'qDisabilityIndepProviderNPI' : 'Physical disability that limits independence - Attesting Provider\'s NPI',

  'qHealthConditionEnvVerification': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Verification Method',
  'qHealthConditionEnvAttestation': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attestation Form Received and Stored',
  'qHealthConditionEnvProviderName': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attesting Providers Name',
  'qHealthConditionEnvProviderNPI': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment - Attesting Providers NPI',

  'qPreSurgicalVerification': 'Requiring pre-surgical or procedure care - Verification Method',
  'qPreSurgicalAttestation': 'Requiring pre-surgical or procedure care - Attestation Form Received and Stored',
  'qPreSurgicalProviderName': 'Requiring pre-surgical or procedure care - Attesting Providers Name',
  'qPreSurgicalProviderNPI': 'Requiring pre-surgical or procedure care - Attesting Providers NPI',

  'qAcuteCareVerification': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Verification Method',
  'qAcuteCareAttestation': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attestation Form Received and Stored',
  'qAcuteCareProviderName': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attesting Providers Name',
  'qAcuteCareProviderNPI': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness, and at risk for incurring other Medicaid state plan services - Attesting Providers NPI',

  'qRefrigeratedMedsVerification': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Verification Method',
  'qRefrigeratedMedsAttestation': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attestation Form Received and Stored',
  'qRefrigeratedMedsProviderName': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attesting Providers Name',
  'qRefrigeratedMedsProviderNPI': 'Prescribed medication requiring refrigeration for the management of a chronic condition - Attesting Providers NPI',

  'qBreastMilkFridgeVerify': 'Requires refrigeration for breast milk - Verification Method',
  'qBreastMilkFridgeMemberAttestation': 'Requires refrigeration for breast milk - Member Attests',

  'qTransportationAccess': 'Do you have difficulty accessing transportation when you need it?',
  // 'qTransportationEffect': 'How does not having transportation affect you?', // deleted in V5
  'qTransportationHelp': 'What kind of transportation help do you need? Please select all that apply:',
  'qTransportationServicesReceived': 'Do you already receive any transportation services?',
  'qTransportationServicesDescription': 'Please describe the transportation services you currently receive:',
  'qNutritionalCounseling': 'Are you currently receiving nutritional counseling or education provided through a New York State (NYS) social services program?',
  'qWICProgram': 'Are you or your children currently participating in the Women, Infants, and Children (WIC) program provided by New York State (NYS)?',
  'qHomeDeliveredMeals': 'Are you currently receiving home-delivered meals or food services through a New York State (NYS) social services program?',
  'qLivingSituation': 'Which best describes your current living situation?',
  'qHousingIssues': 'What specific housing issues are you experiencing? Select all that apply.',

  'qCareRecoveryNeed': 'Do you currently need care to recover from an illness or injury, prepare for a surgery or procedure, or transition out of a hospital or other facility?',
  'qHospitalRisk': 'Are you at risk of needing to go back to the hospital or emergency room if you don\'t get this care?',
  'qHousingProvider': 'Are you currently working with a housing provider or program?',
  'qHealthyHomesProgram': 'Do you participate in the Healthy Homes Program or any similar program provided by New York State (NYS) to address home environmental health hazards?',
  'qHousingWaitlists': 'Are you on any housing waitlists (e.g., HUD, Section 8, local housing authority, or other voucher programs) or receive a rental subsidy?',
  'qUtilitiesIssues': 'Are you experiencing any issues with your utilities?',
  'qUtilitiesIssuesTypes': 'Which of the following utility issues are you experiencing?',
  'qUtilitiesAssistanceType': 'What type of utility assistance do you need? Select all that apply.',
  'qUtilitiesProgramsReceived': 'Do you currently receive any utilities assistance programs?',
  'qUtilitiesProgramsDescription': 'Please specify the utilities assistance programs that you currently receive:',
  'qEmploymentSituation': 'Which of the following best describes your current employment situation?',

  'qServiceDuplicationCheck': 'NYS Service Duplication Check',
  'qNavigatorNotes': 'Navigator Notes:',
  'qOtherPrograms': 'Are there any other programs or services you\'re currently using that provide help with housing, food, healthcare, or other daily needs?',
  'qAdditionalPrograms': 'Additional Programs and Services:',
};

export const stripQuotes = (text) => text ? text.replace(/'/g, '') : null;

const getOptionDictionaryV3 = () => {
  let OPTION_DICTIONARY = {
    'oVerifiedMemberIdentity': "I was able to verify member\'s identity.",
    'oUnverifiedMemberIdentity': 'I was not able to verify member\'s identity.',
    'oVerifyMedicaidEnrollmentGeneralVerified': 'I was able to verify the member is currently enrolled in Medicaid.', // // Option only before April 8, 2025
    'oVerifyMedicaidEnrollmentConfirmed': 'I was able to verify the member is currently enrolled in Medicaid Managed Care.',
    'oVerifyMedicaidEnrollmentFFS': 'I was able to verify the member is currently enrolled in Medicaid Fee-for-Service.',
    'oVerifyMedicaidEnrollmentUnconfirmed': 'I was not able to verify the member is currently enrolled in Medicaid.',
    'oMemberDoesAttest': 'Member attests to provide accurate and complete information.',
    'oMemberDoesNotAttest': 'Member does not attest to provide accurate and complete information.',
    'qMemberCIN': 'Member\'s Medicaid Client Identification Number (CIN)',
    'qProfileFieldsCaptured': 'Check off that each of the following fields were captured in the Profile section of the member\'s facesheet:',
    'pregnantAndPostpartum': 'Pregnant and Postpartum Persons',
    'pregnantAndPostpartumV3': 'Pregnant or Postpartum Person',
    'highRiskChildUnderEighteen': 'High-Risk Children Under 18 Years Old',
    'highRiskChildUnderEighteenV3': 'High-Risk Child Under 18 Years Old',
    'individualsChronicReleased': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days',
    'asthma': 'Uncontrolled Asthma',
    'memberConsentsToConnect': 'Member consents to being connected with enhanced HRSN services.',
    'idd': 'Individuals with∂ Intellectual or Developmental Disabilities',
    'atRiskThermo': 'At Risk of Thermoregulation Interference',
    'sud': 'Individuals Facing Substance Use Challenges', // needed for V2 eligibility rules
    'mentalHealth': 'Individuals with Serious Mental Health Needs', // needed for V2 eligibility rules
    'chronicCondition': 'Chronic Conditions',
    'juvenileJustice': 'Juvenile Justice-Involved Youth, Foster Care Youth, or Under Kinship Care', // V2 or V3
    'enternalOrParenteral': 'Require Enteral or Parenteral Nutrition Therapy',
    'medicaidHighUtilizer': 'Medicaid High Utilizer',
    'enrolledNYS': 'Individuals Enrolled in a NYS Health Home',
    'enrolledNYSV3': 'Enrolled in a NYS-designated Health Home Program',
    'otherPopulations': 'Other Eligible Population',
    'childNutrition': 'High Risk Children Under 18 Nutrition Only',
    'childNutritionV3': 'High-Risk Children Under 18 Years Old Nutrition Only',
    'qDisabilityIndependence': 'Physical disability that limits independence',

    'heatRelatedIllness': 'Previous Heat-Related Illness Requiring ER or Urgent Care Visit',
    'coldRelatedIllness': 'Previous Cold-Related Illness Requiring ER or Urgent Care Visit',
    'heatRelatedIllnessV3': 'Experienced Heat-Related Illness Requiring ER or Urgent Care Visit',
    'coldRelatedIllnessV3': 'Experienced Cold-Related Illness Requiring ER or Urgent Care Visit',

    'qHealthConditionEnvironment': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment',
    'qPreSurgicalCare': 'Requiring pre-surgical or procedure care as indicated by a medical professional',
    'qAcuteCareHospitalization': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness',
    'qRecuperationCare': 'Requiring recuperation and care for an illness or injury',
    'qMedicaidServiceRisk': 'At risk for incurring other Medicaid state plan services, such as inpatient hospitalization or Emergency Department visits',
    'qRefrigerationBreastMilk': 'Pregnant and postpartum persons that require refrigeration for breast milk',
    'qRefrigeratedMedication': 'Prescribed medication requiring refrigeration for the management of a chronic condition',
    'oAsthmaInpatient12mo': 'One or more hospital inpatient stays related to asthma within the last 12 months',
    'oAsthmaEDVisits12mo': 'Two or more ED visits related to asthma within last 12 months',
    'oAsthmaUrgentCare12mo': 'Three or more urgent care visits related to asthma within the last 12 months',
    'oAsthmaSteroidRx12mo': 'Two or more prescribing events for oral steroid use related to an asthma diagnosis within the last 12 months',
    'oAsthmaInhalerRx12mo': 'Three to eleven prescribing events for rescue inhaler including albuterol within the last 12 months',

    'oManagedLongTermCare': 'Managed Long-Term Care (MLTC)',
    'oMMMC': 'Mainstream Medicaid Managed Care (MMMC)',
    'oMAP': 'Medicaid Advantage Plus (MAP)',
    'oHARP': 'Health and Recovery Plan (HARP)',
    'oHIVSNPS': 'HIV Special Needs Plan (HIV-SNPS)',
    'oOtherNotListedPlan': 'Other / Not Listed',

    'oCannotTravelAlone': 'I am unable to travel or wait for services alone or have a physical, cognitive, mental or developmental limitation that impact my ability to travel alone.',
    'oNoWorkingVehicle': "I don't have access to a working vehicle.",
    'oNoDriversLicense': "I don't have a valid driver's license.",
    'oFoodPrescriptions': 'Food Prescriptions (Voucher / Boxes)',
    'oPantryGroceries': 'Fresh Produce and Nonperishable Groceries - Pantry Stocking',

    'oNoACAfford': "I can't cool my home because I can't afford it.",
    'oNoHeatAfford': "I can't heat my home because I can't afford it.",
    'oNoElectricityAfford': "I can't get electricity because I can't afford it.",
    'oNoRunningWater': "I don't have running water in my home.",
    'oElectricityShutoff': 'My electricity has been shut off.',
    'oNoUtilitiesAccess': 'No access to water, electricity, or other utilities.',
    'oNoHeatingOrCooling': 'No heating or cooling when needed.',
    'oFoodPantryAccess': 'Access to food pantries or food banks',
    'oGroceryShoppingHelp': 'Assistance with grocery shopping',

    'oNutritionalCounseling': 'Nutritional counseling or education',

    'oCookingSupplies': 'Cooking supplies',
    'oMedicallyTailoredMeals': 'Medically Tailored Meals (MTM) In-lieu of Services (ILOS)',

    'oPlaceToLiveWithProblems': "I have a place to live, but I'm having some problems with it.",
    'oStayingWithFamilyOrFriends': 'I\'m currently staying with friends or family temporarily.',
    'oStayingInShelter': 'I\'m staying in a shelter or temporary housing.',
    'oStayingNotLiving': 'I\'m sleeping in a place not meant for living (e.g., outside, car).',
    'oStayingNotLivingSafe': 'I\'m sleeping in a place not meant for living, but I feel safe.',
    'oMightLoseHousing': 'I have been notified in writing that my right to occupy my current housing or living situation will be terminated.',
    'oBehindOnRent': 'I\'m behind on rent or mortgage payments.',
    'oHousingCostsTooMuch': 'My housing costs too much for me to afford.',
  };
  // util exists because surveyjs custom dropdown component breaks due to usage of ' character:
  Object.keys(OPTION_DICTIONARY).forEach((key) => {
    OPTION_DICTIONARY[key] = stripQuotes(OPTION_DICTIONARY[key]);
  });
  return OPTION_DICTIONARY;
};

const getOptionDictionary = () => {
  let OPTION_DICTIONARY = {
    'oVerifiedMemberIdentity': "I was able to verify member\'s identity",
    'oUnverifiedMemberIdentity': 'I was not able to verify member\'s identity',
    'oVerifyMedicaidEnrollmentGeneralVerified': 'I was able to verify the member is currently enrolled in Medicaid', // // Option only before April 8, 2025
    'oVerifyMedicaidEnrollmentConfirmed': 'I was able to verify the member is currently enrolled in Medicaid Managed Care',
    'oVerifyMedicaidEnrollmentFFS': 'I was able to verify the member is currently enrolled in Medicaid Fee-for-Service',
    'oVerifyMedicaidEnrollmentUnconfirmed': 'I was not able to verify the member is currently enrolled in Medicaid',
    'oMemberDoesAttest': 'Member attests to provide accurate and complete information',
    'oMemberDoesNotAttest': 'Member does not attest to provide accurate and complete information',
    'qMemberCIN': 'Member\'s Medicaid Client Identification Number (CIN)',
    'qProfileFieldsCaptured': 'Check off that each of the following fields were captured in the Profile section of the member\'s facesheet:',
    'pregnantAndPostpartum': 'Pregnant and Postpartum Persons',
    'pregnantAndPostpartumV3': 'Pregnant or Postpartum Person',
    'highRiskChildUnderEighteen': 'High-Risk Children Under 18 Years Old',
    'highRiskChildUnderEighteenV3': 'High-Risk Child Under 18 Years Old',
    'individualsChronicReleased': 'Individuals with a Chronic Condition Released from Incarceration in the Past 90 Days',
    'asthma': 'Uncontrolled Asthma',
    'memberConsentsToConnect': 'Member consents to being connected with enhanced HRSN services',
    'idd': 'Individuals with Intellectual and Developmental Disabilities (IDD)',
    'atRiskThermo': 'Risk of Thermoregulation Interference',
    'sud': 'Individuals Facing Substance Use Challenges', // needed for V2 eligibility rules
    'mentalHealth': 'Individuals with Serious Mental Health Needs', // needed for V2 eligibility rules
    'chronicCondition': 'Chronic Conditions',
    'juvenileJustice': 'Juvenile Justice-Involved Youth, Foster Care Youth, or Under Kinship Care', // V2 or V3
    'enternalOrParenteral': 'Enteral or Parenteral Nutrition Therapy',
    'medicaidHighUtilizer': 'Medicaid High Utilizer',
    'enrolledNYS': 'Individuals Enrolled in a NYS Health Home',
    'enrolledNYSV3': 'Enrolled in a NYS-designated Health Home Program',
    'otherPopulations': 'Other Eligible Population',
    'childNutrition': 'High Risk Children Under 18 Nutrition Only',
    'childNutritionV3': 'High-Risk Children Under 18 Years Old Nutrition Only',
    'qDisabilityIndependence': 'Physical disability that limits independence',

    'heatRelatedIllness': 'Heat-Related Illness Requiring ER or UC Visit',
    'coldRelatedIllness': 'Cold-Related Illness Requiring ER or UC Visit',
    'heatRelatedIllnessV3': 'Experienced Heat-Related Illness Requiring ER or UC Visit',
    'coldRelatedIllnessV3': 'Experienced Cold-Related Illness Requiring ER or UC Visit',

    'qHealthConditionEnvironment': 'Has a health condition or is at risk for a health condition that is exacerbated by the individual\'s physical living environment',
    'qPreSurgicalCare': 'Requiring pre-surgical or procedure care as indicated by a medical professional',
    'qAcuteCareHospitalization': 'Admission or discharge from an Acute Care hospitalization related to a health condition or illness',
    'qRecuperationCare': 'Requiring recuperation and care for an illness or injury',
    'qMedicaidServiceRisk': 'At risk for incurring other Medicaid state plan services, such as inpatient hospitalization or Emergency Department visits',
    'qRefrigerationBreastMilk': 'Pregnant and postpartum persons that require refrigeration for breast milk',
    'qRefrigeratedMedication': 'Prescribed medication requiring refrigeration for the management of a chronic condition',
    'oAsthmaInpatient12mo': 'One or more hospital inpatient stays related to asthma within the last 12 months',
    'oAsthmaEDVisits12mo': 'Two or more ED visits related to asthma within last 12 months',
    'oAsthmaUrgentCare12mo': 'Three or more urgent care visits related to asthma within the last 12 months',
    'oAsthmaSteroidRx12mo': 'Two or more prescribing events for oral steroid use related to an asthma diagnosis within the last 12 months',
    'oAsthmaInhalerRx12mo': 'Three to eleven prescribing events for rescue inhaler including albuterol within the last 12 months',

    'oManagedLongTermCare': 'Managed Long-Term Care (MLTC)',
    'oMMMC': 'Mainstream Medicaid Managed Care (MMMC)',
    'oMAP': 'Medicaid Advantage Plus (MAP)',
    'oHARP': 'Health and Recovery Plan (HARP)',
    'oHIVSNPS': 'HIV Special Needs Plan (HIV-SNPS)',
    'oOtherNotListedPlan': 'Other / Not Listed',

    'oCannotTravelAlone': 'I am unable to travel or wait for services alone or have a physical, cognitive, mental or developmental limitation that impact my ability to travel alone',
    'oNoWorkingVehicle': "I don't have access to a working vehicle",
    'oNoDriversLicense': "I don't have a valid driver's license",
    'oFoodPrescriptions': 'Food Prescriptions (Voucher / Boxes)',
    'oPantryGroceries': 'Fresh Produce and Nonperishable Groceries - Pantry Stocking',

    'oNoACAfford': "I can't cool my home because I can't afford it",
    'oNoHeatAfford': "I can't heat my home because I can't afford it",
    'oNoElectricityAfford': "I can't get electricity because I can't afford it",
    'oNoRunningWater': "I don't have running water in my home",
    'oElectricityShutoff': 'My electricity has been shut off',
    'oNoUtilitiesAccess': 'No access to water, electricity, or other utilities',
    'oNoHeatingOrCooling': 'No heating or cooling when needed',
    'oWaterLeaks': 'Water leaks',
    'oFoodPantryAccess': 'Access to food pantries or food banks',
    'oGroceryShoppingHelp': 'Assistance with grocery shopping',

    'oNutritionalCounseling': 'Nutritional counseling or education',

    'oCookingSupplies': 'Cooking supplies',
    'oMedicallyTailoredMeals': 'Medically Tailored Meals (MTM) In-lieu of Services (ILOS)',

    'oStablePlaceToLive': 'I have a stable and safe place to live with no problems',
    'oNoPlaceToLive': 'I don\'t have a steady place to live right now',
    'oPlaceToLiveWithProblems': "I have a place to live, but I'm having some problems with it",
    'oStayingWithFamilyOrFriends': 'I\'m currently staying with friends or family temporarily',
    'oStayingInShelter': 'I\'m staying in a shelter or temporary housing',
    'oStayingNotLiving': 'I\'m sleeping in a place not meant for living (e.g., outside, car)',
    'oStayingNotLivingSafe': 'I\'m sleeping in a place not meant for living, but I feel safe',
    'oMightLoseHousing': 'I have been notified in writing that my right to occupy my current housing or living situation will be terminated',
    'oBehindOnRent': 'I\'m behind on rent or mortgage payments',
    'oHousingCostsTooMuch': 'My housing costs too much for me to afford',
    'oHousingWorriedAboutEviction': 'I\'m worried about being evicted',

    'oEnteralOrParenteralNutritionTherapy': 'Enteral or Parenteral Nutrition Therapy',

    'oDuplicationNutritionalCounseling': 'Nutritional Counseling',
    'oHealthyHomes': 'Healthy Homes',
    'oDuplicationDevelopmentalDisabilities': 'Office for Persons with Developmental Disabilities (OPWDD) Waiver',
    'oDuplicationTraumaticBrainInjury': 'Traumatic Brain Injury (TBI) Waiver',
    'oDuplicationNursingHomeTransition': 'Nursing Home Transition Diversion (NHTD) Waiver',
    'oDuplicationChildrenWaiver': 'Childrens Waiver',

    'oNotCurrentlyEmployed': 'I am not currently employed and am looking for work',
    'oEmployedNeedMoreHours': 'I am employed but need more hours or a better job',
    'oEmployedAndSatisfied': 'I am employed and satisfied with my current job',


  };
  // util exists because surveyjs custom dropdown component breaks due to usage of ' character:
  Object.keys(OPTION_DICTIONARY).forEach((key) => {
    OPTION_DICTIONARY[key] = stripQuotes(OPTION_DICTIONARY[key]);
  });
  return OPTION_DICTIONARY;
};

export const OPTION_DICTIONARY = getOptionDictionary();
export const OPTION_DICTIONARY_V3 = getOptionDictionaryV3();

const matchElement = (q) => {
  const text = q.primary_text;
  let elementName = null;
  let elementType = null;
  let elementVisible = true;
  let isRequired = false;
  let inputType = null;
  let visibleIf = null;
  // by default, element is included in answer only if it has a value
  // if set to true, includes element in the answer payload even if empty
  // if empty, value passed will be ''
  let includeInAnswers = false;
  let page = 2;

  if (q.type === 'datetime') {
    // elementType = 'datetime';
    elementType = 'text';
    inputType = SURVEYJS_INPUT_TYPES.DATE;
  }
  if (q.type === 'select') {
    elementType = 'dropdown';
  }
  if (q.type === 'select_multiple') {
    elementType = 'dropdown-multiselect';
  }

  if (q.type === 'text') {
    elementType = 'text';
  }

  const keysRequiredAndNotVisible = [
    'qDisabilityIndepVerification',
    'qDisabilityIndepAttestation',
    'qDisabilityIndepProviderName',
    'qDisabilityIndepProviderNPI',
    'qHealthConditionEnvVerification',
    'qHealthConditionEnvAttestation',
    'qHealthConditionEnvProviderName',
    'qHealthConditionEnvProviderNPI',
    'qPreSurgicalVerification',
    'qPreSurgicalAttestation',
    'qPreSurgicalProviderName',
    'qPreSurgicalProviderNPI',
    'qAcuteCareVerification',
    'qAcuteCareAttestation',
    'qAcuteCareProviderName',
    'qAcuteCareProviderNPI',
    'qRefrigeratedMedsVerification',
    'qRefrigeratedMedsAttestation',
    'qRefrigeratedMedsProviderName',
    'qRefrigeratedMedsProviderNPI',
    'qBreastMilkFridgeVerify',
    'qBreastMilkFridgeMemberAttestation',
  ];

  for (const key of keysRequiredAndNotVisible) {
    if (text === ELEMENT_DICTIONARY[key]) {
      isRequired = true;
      elementName = key;
      elementVisible = false;
    }
  }

  if (text === ELEMENT_DICTIONARY.qDateAttempt1) {
    page = 1;
    elementName = 'qDateAttempt1';
  }

  if (text === ELEMENT_DICTIONARY.qModalityAttempt1) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qModalityAttempt1';
  }

  if (text === ELEMENT_DICTIONARY.qOutcomeAttempt1) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qOutcomeAttempt1';
  }

  if (text === ELEMENT_DICTIONARY.qDateAttempt2) {
    page = 1;
    elementName = 'qDateAttempt2';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qModalityAttempt2) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qModalityAttempt2';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOutcomeAttempt2) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qOutcomeAttempt2';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qDateAttempt3) {
    page = 1;
    elementName = 'qDateAttempt3';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qModalityAttempt3) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qModalityAttempt3';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOutcomeAttempt3) {
    page = 1;
    elementType = SURVEYJS_TYPES.RADIO;
    elementName = 'qOutcomeAttempt3';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qVerifyMedicaidEnrollment) {
    isRequired = true;
    elementName = 'qVerifyMedicaidEnrollment';
  }
  if (text === ELEMENT_DICTIONARY.qNYExcludedPopulation) {
    isRequired = true;
    elementName = 'qNYExcludedPopulation';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qImmediateFamily) {
    isRequired = true;
    elementName = 'qImmediateFamily';
    elementType = SURVEYJS_TYPES.TEXT;
    inputType = SURVEYJS_INPUT_TYPES.NUMBER;
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qImmediateFamilyMedicaid) {
    isRequired = false;
    elementName = 'qImmediateFamilyMedicaid';
    elementType = SURVEYJS_TYPES.TEXT;
    inputType = SURVEYJS_INPUT_TYPES.NUMBER;
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qListAdditionalNameAndDOB) {
    isRequired = false;
    elementName = 'qListAdditionalNameAndDOB';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qAreYouCurrentlyEmployed) {
    isRequired = true;
    elementName = 'qAreYouCurrentlyEmployed';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qConfirmAccurateInfo) {
    isRequired = true;
    elementName = 'qConfirmAccurateInfo';
  }
  if (text === ELEMENT_DICTIONARY.qVerifyIdentity) {
    isRequired = true;
    page = 2;
    elementName = 'qVerifyIdentity';
  }
  if (text === ELEMENT_DICTIONARY.qMemberCIN) {
    isRequired = false;
    elementName = 'qMemberCIN';
  }
  if (text === ELEMENT_DICTIONARY.qProfileFieldsCaptured) {
    isRequired = false;
    elementName = 'qProfileFieldsCaptured';
  }
  if (text === ELEMENT_DICTIONARY.qDifficultyWalking) {
    isRequired = true;
    elementName = 'qDifficultyWalking';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qDifficultyDressing) {
    isRequired = true;
    elementName = 'qDifficultyDressing';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qSelectScreening) {
    page = 1;
    isRequired = true;
    elementType = SURVEYJS_TYPES.SELECT;
    elementName = 'qSelectScreening';
    elementVisible = true;
  }

  // After Select Screening
  if (text === ELEMENT_DICTIONARY.qEnhancedPopulations) {
    isRequired = false;
    elementName = 'qEnhancedPopulations';
    includeInAnswers = true;
  }
  if (text === ELEMENT_DICTIONARY.qMedicaidVerification) {
    isRequired = true;
    elementName = 'qMedicaidVerification';
    elementVisible = false;
    includeInAnswers = true;
  }
  if (text === ELEMENT_DICTIONARY.qMedicaidVerificationAttestationForm) {
    isRequired = true;
    elementName = 'qMedicaidVerificationAttestationForm';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qMedicaidVerificationProviderName) {
    isRequired = true;
    elementName = 'qMedicaidVerificationProviderName';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qMedicaidVerificationProviderNPI) {
    isRequired = true;
    elementName = 'qMedicaidVerificationProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qHealthHomeVerification) {
    isRequired = true;
    elementName = 'qHealthHomeVerification';
    elementVisible = false;
    includeInAnswers = true;
  }
  if (text === ELEMENT_DICTIONARY.qHealthHomeVerificationAttestationForm) {
    isRequired = true;
    elementName = 'qHealthHomeVerificationAttestationForm';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qHealthHomeVerificationProviderName) {
    isRequired = true;
    elementName = 'qHealthHomeVerificationProviderName';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qHealthHomeVerificationProviderNPI) {
    isRequired = true;
    elementName = 'qHealthHomeVerificationProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qAreYouPregnant) {
    isRequired = true;
    elementName = 'qAreYouPregnant';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qPostpartumStartDate) {
    isRequired = true;
    elementName = 'qPostpartumStartDate';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qChildcareHelp) {
    isRequired = false;
    elementName = 'qChildcareHelp';
  }

  if (text === ELEMENT_DICTIONARY.qEstimatedDeliveryDate) {
    isRequired = true;
    elementName = 'qEstimatedDeliveryDate';
    includeInAnswers = true;
  }

  if (text === ELEMENT_DICTIONARY.qPregnancyVerificationMethod) {
    isRequired = true;
    elementName = 'qPregnancyVerificationMethod';
    elementVisible = false;
    includeInAnswers = true;
  }
  if (text === ELEMENT_DICTIONARY.qPregnancyVerificationProviderName) {
    isRequired = true;
    elementName = 'qPregnancyVerificationProviderName';
  }
  if (text === ELEMENT_DICTIONARY.qPregnancyVerificationProviderNPI) {
    isRequired = true;
    elementName = 'qPregnancyVerificationProviderNPI';
  }
  if (text === ELEMENT_DICTIONARY.qPregnancyVerificationAttestationForm) {
    isRequired = true;
    elementName = 'qPregnancyVerificationAttestationForm';
  }
  if (text === ELEMENT_DICTIONARY.qPregnancyMemberAttestation) {
    isRequired = true;
    elementName = 'qPregnancyMemberAttestation';
  }

  if (text === ELEMENT_DICTIONARY.qChildVerificationMethod) {
    isRequired = true;
    elementName = 'qChildVerificationMethod';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qChildProviderName) {
    isRequired = true;
    elementName = 'qChildProviderName';
  }

  if (text === ELEMENT_DICTIONARY.qChildProviderNPI) {
    isRequired = true;
    elementName = 'qChildProviderNPI';
  }

  if (text === ELEMENT_DICTIONARY.qChildAttestationStored) {
    isRequired = true;
    elementName = 'qChildAttestationStored';
  }

  if (text === ELEMENT_DICTIONARY.qConditionIncarcerationVerification) {
    isRequired = true;
    elementName = 'qConditionIncarcerationVerification';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qConditionIncarcerationDocsStored) {
    isRequired = true;
    elementName = 'qConditionIncarcerationDocsStored';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIncarcerationChronicConditionVerification) {
    isRequired = true;
    elementName = 'qIncarcerationChronicConditionVerification';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIncarcerationChronicConditionAttestationForm) {
    isRequired = true;
    elementName = 'qIncarcerationChronicConditionAttestationForm';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIncarcerationChronicConditionProviderName) {
    isRequired = true;
    elementName = 'qIncarcerationChronicConditionProviderName';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIncarcerationChronicConditionProviderNPI) {
    isRequired = true;
    elementName = 'qIncarcerationChronicConditionProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIntellectualDisabilitiesVerification) {
    isRequired = true;
    elementName = 'qIntellectualDisabilitiesVerification';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIntellectualDisabilitiesAttestation) {
    isRequired = true;
    elementName = 'qIntellectualDisabilitiesAttestation';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qIntellectualDisabilitiesProviderName) {
    isRequired = true;
    elementName = 'qIntellectualDisabilitiesProviderName';
    elementVisible = false;
  }
  
  if (text === ELEMENT_DICTIONARY.qIntellectualDisabilitiesProviderNPI) {
    isRequired = true;
    elementName = 'qIntellectualDisabilitiesProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOtherPopulationsVerification) {
    isRequired = true;
    elementName = 'qOtherPopulationsVerification';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOtherPopulationsVerificationProviderName) {
    isRequired = true;
    elementName = 'qOtherPopulationsVerificationProviderName';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOtherPopulationsVerificationProviderNPI) {
    isRequired = true;
    elementName = 'qOtherPopulationsVerificationProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qOtherPopulationsVerificationAttestationForm) {
    isRequired = true;
    elementName = 'qOtherPopulationsVerificationAttestationForm';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qChildNutritionVerification) {
    isRequired = true;
    elementName = 'qChildNutritionVerification';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qChildNutritionVerificationProviderName) {
    isRequired = true;
    elementName = 'qChildNutritionVerificationProviderName';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qChildNutritionVerificationProviderNPI) {
    isRequired = true;
    elementName = 'qChildNutritionVerificationProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qChildNutritionVerificationAttestationForm) {
    isRequired = true;
    elementName = 'qChildNutritionVerificationAttestationForm';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qTransportationAccess) {
    isRequired = true;
    elementName = 'qTransportationAccess';
  }
  if (text === ELEMENT_DICTIONARY.qTransportationTroubleReasons) {
    isRequired = true;
    elementName = 'qTransportationTroubleReasons';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qTypesOfActivitiesTransportation) {
    isRequired = false;
    elementName = 'qTypesOfActivitiesTransportation';
    elementVisible = false;
  }
  // if (text === ELEMENT_DICTIONARY.qTransportationEffect) {
  //   isRequired = false;
  //   elementName = 'qTransportationEffect';
  // }
  if (text === ELEMENT_DICTIONARY.qTransportationHelp) {
    isRequired = true;
    elementName = 'qTransportationHelp';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qTransportationServicesReceived) {
    isRequired = false;
    elementName = 'qTransportationServicesReceived';
  }
  if (text === ELEMENT_DICTIONARY.qTransportationServicesDescription) {
    isRequired = false;
    elementName = 'qTransportationServicesDescription';
  }
  if (text === ELEMENT_DICTIONARY.qFoodAssistanceType) {
    isRequired = true;
    elementName = 'qFoodAssistanceType';
  }
  if (text === ELEMENT_DICTIONARY.qFoodPreparationAbility) {
    isRequired = false;
    elementName = 'qFoodPreparationAbility';
  }
  if (text === ELEMENT_DICTIONARY.qDoYouHaveCookingSupplies) {
    isRequired = false;
    elementName = 'qDoYouHaveCookingSupplies';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qDoYouHaveDietaryRestrictions) {
    isRequired = false;
    elementName = 'qDoYouHaveDietaryRestrictions';
  }
  if (text === ELEMENT_DICTIONARY.qHowManyPeopleNeedFoodAssistance) {
    isRequired = false;
    elementName = 'qHowManyPeopleNeedFoodAssistance';
    elementType = SURVEYJS_TYPES.TEXT;
    inputType = SURVEYJS_INPUT_TYPES.NUMBER;
  }
  if (text === ELEMENT_DICTIONARY.qCanPrepareMeals) {
    isRequired = false;
    elementName = 'qCanPrepareMeals';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qCaregiverPrepareMeals) {
    isRequired = false;
    elementName = 'qCaregiverPrepareMeals';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qRefrigerationBreastMilk) {
    isRequired = false;
    elementVisible = false;
    elementName = 'qRefrigerationBreastMilk';
  }
  if (text === ELEMENT_DICTIONARY.qRefrigerationMedication) {
    isRequired = false;
    elementVisible = false;
    elementName = 'qRefrigerationMedication';
  }

  if (text === ELEMENT_DICTIONARY.qNutritionalCounseling) {
    isRequired = false;
    elementName = 'qNutritionalCounseling';
  }

  if (text === ELEMENT_DICTIONARY.qWICProgram) {
    isRequired = false;
    elementName = 'qWICProgram';
  }

  if (text === ELEMENT_DICTIONARY.qSNAPBenefits) {
    isRequired = true;
    elementName = 'qSNAPBenefits';
  }
  if (text === ELEMENT_DICTIONARY.qReceiveTANF) {
    isRequired = true;
    elementName = 'qReceiveTANF';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qHomeDeliveredMeals) {
    isRequired = false;
    elementName = 'qHomeDeliveredMeals';
  }

  if (text === ELEMENT_DICTIONARY.qLivingSituation) {
    isRequired = true;
    elementName = 'qLivingSituation';
  }

  if (text === ELEMENT_DICTIONARY.qHousingIssues) {
    isRequired = false;
    elementName = 'qHousingIssues';
  }
  if (text === ELEMENT_DICTIONARY.qHousingSafetyConcerns) {
    isRequired = true;
    elementName = 'qHousingSafetyConcerns';
  }
  if (text === ELEMENT_DICTIONARY.qHousingConcerns) {
    isRequired = true;
    elementName = 'qHousingConcerns';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qCareRecoveryNeed) {
    isRequired = false;
    elementName = 'qCareRecoveryNeed';
  }

  if (text === ELEMENT_DICTIONARY.qHospitalRisk) {
    isRequired = false;
    elementName = 'qHospitalRisk';
  }

  if (text === ELEMENT_DICTIONARY.qHousingProvider) {
    isRequired = false;
    elementName = 'qHousingProvider';
  }

  if (text === ELEMENT_DICTIONARY.qHealthyHomesProgram) {
    isRequired = false;
    elementName = 'qHealthyHomesProgram';
  }

  if (text === ELEMENT_DICTIONARY.qHousingWaitlists) {
    isRequired = true;
    elementName = 'qHousingWaitlists';
  }

  if (text === ELEMENT_DICTIONARY.qUtilitiesIssues) {
    isRequired = true;
    elementName = 'qUtilitiesIssues';
  }

  if (text === ELEMENT_DICTIONARY.qUtilitiesIssuesTypes) {
    isRequired = true;
    elementVisible = false;
    elementName = 'qUtilitiesIssuesTypes';
  }

  if (text === ELEMENT_DICTIONARY.qUtilitiesAssistanceType) {
    isRequired = false;
    elementVisible = false;
    elementName = 'qUtilitiesAssistanceType';
  }

  if (text === ELEMENT_DICTIONARY.qUtilitiesProgramsReceived) {
    isRequired = false;
    elementVisible = false;
    elementName = 'qUtilitiesProgramsReceived';
  }

  if (text === ELEMENT_DICTIONARY.qUtilitiesProgramsDescription) {
    isRequired = false;
    elementName = 'qUtilitiesProgramsDescription';
  }

  if (text === ELEMENT_DICTIONARY.qEmploymentSituation) {
    isRequired = true;
    elementName = 'qEmploymentSituation';
  }
  if (text === ELEMENT_DICTIONARY.qWorkInterest) {
    isRequired = false;
    elementName = 'qWorkInterest';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qIncomeOtherSource) {
    isRequired = false;
    elementName = 'qIncomeOtherSource';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qIncomeAnySource) {
    isRequired = true;
    elementName = 'qIncomeAnySource';
    elementVisible = true;
  }
  // if (text === ELEMENT_DICTIONARY.qIncomeAnyOtherSource) {
  //   isRequired = false;
  //   elementName = 'qIncomeAnyOtherSource';
  //   elementVisible = false;
  // }
  if (text === ELEMENT_DICTIONARY.qWhatOtherSourceIncome) {
    isRequired = false;
    elementName = 'qWhatOtherSourceIncome';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qSchoolTrainingHelp) {
    isRequired = true;
    elementName = 'qSchoolTrainingHelp';
    elementVisible = false;
  }
  if (text === 'Do you need assistance with childcare?') {
    isRequired = false;
    elementName = 'qChildcareAssistance';
  }
  if (text === ELEMENT_DICTIONARY.qClinicalCriteria) {
    isRequired = false;
    includeInAnswers = true;
    elementName = 'qClinicalCriteria';
  }
  if (text === ELEMENT_DICTIONARY.qAdditionalClinicalConditions) {
    isRequired = false;
    elementName = 'qAdditionalClinicalConditions';
  }
  if (text === ELEMENT_DICTIONARY.qChronicConditionsVerification) {
    isRequired = true;
    includeInAnswers = true;
    elementName = 'qChronicConditionsVerification';
  }

  if (text === ELEMENT_DICTIONARY.qChronicConditionsProviderName) {
    isRequired = true;
    includeInAnswers = true;
    elementName = 'qChronicConditionsProviderName';
  }

  if (text === ELEMENT_DICTIONARY.qChronicConditionsProviderNPI) {
    isRequired = true;
    includeInAnswers = true;
    elementName = 'qChronicConditionsProviderNPI';
  }

  if (text === ELEMENT_DICTIONARY.qChronicConditionsAttestationStored) {
    isRequired = true;
    includeInAnswers = true;
    elementName = 'qChronicConditionsAttestationStored';
  }

  if (text === ELEMENT_DICTIONARY.qAsthmaVerification) {
    isRequired = true;
    elementName = 'qAsthmaVerification';
  }

  if (text === ELEMENT_DICTIONARY.qAsthmaProviderName) {
    isRequired = true;
    elementName = 'qAsthmaProviderName';
  }

  if (text === ELEMENT_DICTIONARY.qAsthmaProviderNPI) {
    isRequired = true;
    elementName = 'qAsthmaProviderNPI';
  }

  if (text === ELEMENT_DICTIONARY.qAsthmaAttestationStored) {
    isRequired = true;
    elementName = 'qAsthmaAttestationStored';
  }

  if (text === ELEMENT_DICTIONARY.qNutritionTherapyVerification) {
    isRequired = true;
    elementName = 'qNutritionTherapyVerification';
  }

  if (text === ELEMENT_DICTIONARY.qNutritionTherapyProviderName) {
    isRequired = true;
    elementName = 'qNutritionTherapyProviderName';
  }

  if (text === ELEMENT_DICTIONARY.qNutritionTherapyProviderNPI) {
    isRequired = true;
    elementName = 'qNutritionTherapyProviderNPI';
  }

  if (text === ELEMENT_DICTIONARY.qNutritionTherapyAttestationStored) {
    isRequired = true;
    elementName = 'qNutritionTherapyAttestationStored';
  }

  if (text === ELEMENT_DICTIONARY.qHeatIllnessVerification) {
    isRequired = true;
    elementName = 'qHeatIllnessVerification';
  }
  if (text === ELEMENT_DICTIONARY.qHeatIllnessProviderName) {
    isRequired = true;
    elementName = 'qHeatIllnessProviderName';
  }
  if (text === ELEMENT_DICTIONARY.qHeatIllnessProviderNPI) {
    isRequired = true;
    elementName = 'qHeatIllnessProviderNPI';
  }
  if (text === ELEMENT_DICTIONARY.qHeatIllnessAttestationStored) {
    isRequired = true;
    elementName = 'qHeatIllnessAttestationStored';
  }
  if (text === ELEMENT_DICTIONARY.qHeatIllnessAttestHome) {
    isRequired = true;
    elementName = 'qHeatIllnessAttestHome';
  }
  if (text === ELEMENT_DICTIONARY.qColdIllnessVerification) {
    isRequired = true;
    elementName = 'qColdIllnessVerification';
  }
  if (text === ELEMENT_DICTIONARY.qColdIllnessProviderName) {
    isRequired = true;
    elementName = 'qColdIllnessProviderName';
  }
  if (text === ELEMENT_DICTIONARY.qColdIllnessProviderNPI) {
    isRequired = true;
    elementName = 'qColdIllnessProviderNPI';
  }
  if (text === ELEMENT_DICTIONARY.qColdIllnessAttestationStored) {
    isRequired = true;
    elementName = 'qColdIllnessAttestationStored';
  }
  if (text === ELEMENT_DICTIONARY.qColdIllnessAttestHome) {
    isRequired = true;
    elementName = 'qColdIllnessAttestHome';
  }
  if (text === ELEMENT_DICTIONARY.qThermoregulationRiskVerification) {
    isRequired = true;
    elementName = 'qThermoregulationRiskVerification';
  }
  if (text === ELEMENT_DICTIONARY.qThermoregulationRiskProviderName) {
    isRequired = true;
    elementName = 'qThermoregulationRiskProviderName';
    elementVisible = false;
  }
  if (text === ELEMENT_DICTIONARY.qThermoregulationRiskProviderNPI) {
    isRequired = true;
    elementName = 'qThermoregulationRiskProviderNPI';
    elementVisible = false;
  }

  if (text === ELEMENT_DICTIONARY.qThermoregulationRiskAttestationStored) {
    isRequired = true;
    elementName = 'qThermoregulationRiskAttestationStored';
  }
  if (text === ELEMENT_DICTIONARY.qServiceDuplicationCheck) {
    isRequired = false;
    elementName = 'qServiceDuplicationCheck';
  }
  if (text === ELEMENT_DICTIONARY.qOtherPrograms) {
    isRequired = false;
    elementName = 'qOtherPrograms';
  }
  if (text === ELEMENT_DICTIONARY.qAdditionalPrograms) {
    isRequired = false;
    elementName = 'qAdditionalPrograms';
  }
  if (text === ELEMENT_DICTIONARY.qConnectToServices) {
    isRequired = false;
    elementName = 'qConnectToServices';
  }
  if (text === ELEMENT_DICTIONARY.qNavigatorNotes) {
    isRequired = false;
    elementName = 'qNavigatorNotes';
    elementType = 'comment';
  }

  if (!elementName) {
    elementName = null;
    console.error('createElAssessTemplate', q.primary_text);
  }
  if (!elementType) {
    elementType = null;
    console.error('createElAssessTemplate no elementType found', q);
  }

  if (!elementVisible) {
    includeInAnswers = true;
  }

  return {
    elementName,
    elementType,
    visibleIf,
    isRequired,
    elementVisible,
    inputType,
    page,
    includeInAnswers,
  };
};

let htmlIndex = 0;

const createH1Element = (text, name = null) => ({
  "type": "html",
  "name": name || `html_header_${htmlIndex++}`,
  "uuid": null,
  "html": `
    <div class="mb-2 p-3 pb-1 pt-4 bg-gray-100 rounded-lg">
      <h2 class="text-xl font-bold mb-3">${text}</h2>
    </div>
  `,
});

const createH2Element = (text, name = null) => ({
  "type": "html",
  "name": name || `html_header_${htmlIndex++}`,
  "html": `
      <div class="mb-2 p-3 pt-4 pb-1 bg-gray-100 rounded-lg">
        <h2 class="text-xl font-bold mb-3">${text}</h2>
    </div>
  `,
  "uuid": null,
});

const createHTMLElement = (text, name = null) => ({
  "type": "html",
  "name": name || `html_header_${htmlIndex++}`,
  "html": `<h2 class='pb-4'>${text}</h2>`,
  "uuid": null,
});

const createIdentifiedNeedsHTML = (text) => ({
  "type": "html",
  "name": "qIdentifiedNeedsHtml",
  "uuid": null,
  "html": "<p></p>",
  "visible": true,
});

const createStepEightHTML = () => ({
  "type": "html",
  "name": "hStepEightHtml",
  "uuid": null,
  "html": `
    <div class="p-4 bg-gray-100 rounded-lg mb-6">
      <h2 class="text-xl font-bold mb-3">
        Step 8: Confirm that the Medicaid Managed Care Member Wants to Receive Enhanced HRSN Services for Which They are Eligible
      </h2>

      <div>
        <h3 class="font-semibold mb-2">8.1 Enhanced HRSN Services Member is Eligible For:</h3>
      </div>
    </div>
  `
});

const createEnhancedPopulationsHTML = (text) => ({
  "type": "html",
  "name": "hEnhancedPopulationsHtml",
  "uuid": null,
  "html": `
    <div class="p-4 bg-gray-100 rounded-lg mb-6">
      <h2 class="text-xl font-bold mb-3">Step 5: Check if the Member is Included in an Enhanced Population</h2>

      <div class="mb-6">
        <h3 class="font-semibold mb-2">5.1 Enhanced Populations from ESMF</h3>
        <p>
          Based on the Enhanced Services Member File (ESMF), the member is identified as part of the following Enhanced Population(s):
        </p>
      </div>

      <div class="mb-6">
        <h3 class="font-semibold mb-2">5.2. Member Confirmation of Enhanced Populations</h3>
        <div>
          <h4 class="font-semibold mb-2">Suggested Language:</h4>
          <p class="italic">
            "To make sure you receive all the support and services you might be eligible for, I'd like to review some groups that qualify for additional assistance. I'll go through each group one by one. Please let me know if it applies to you."
          </p>
        </div>
      </div>
    </div>
  `
});

const createNYSServiceDuplicationCheckHTML = (text) => ({
  "type": "html",
  "name": "hServiceDuplicationCheckHtml",
  "uuid": null,
  "html": `
    <div class="p-4 bg-gray-100 rounded-lg mb-6">
      <h2 class="text-xl font-bold mb-3">7.3. NYS Service Duplication Check</h2>

      <div class="space-y-6">
        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "To make sure we provide you with the best support without overlapping services you may already have, I'd like to ask about any assistance or programs you're currently receiving. This helps us coordinate your care effectively and ensure you're getting the most appropriate help."
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Are you part of a program called a Health Home that helps organize your healthcare services and appointments?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Do you receive specialized services or support through programs for people with developmental disabilities?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Do you get any special services or support because you've experienced a traumatic brain injury?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Are you part of a program that helps you stay in your home instead of moving to a nursing home, providing you with extra support?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Does your child receive special services or support through a program designed for children with significant health needs?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Are you enrolled in a health plan that combines Medicaid and Medicare services?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Do you have a health plan that helps with long-term care services like home care or adult day care, but doesn't cover all your medical services?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "Do you receive financial assistance or other support services through a program called TANF, which helps families in need?"
          </p>
        </div>
      </div>
    </div>
  `
});

const createConflictOfInterestHTML = () => ({
  "type": "html",
  "name": "hConflictOfInterestHtml",
  "uuid": null,
  "html": `
    <div class="p-4 bg-gray-100 rounded-lg mb-6">
      <h2 class="text-xl font-bold mb-3">
        Conflict of Interest
      </h2>
      <div>
        <h3 class="font-semibold mb-2">
          Social Care Navigators should verbally 
          inform the Member of a potential Conflict 
          of Interest (COI) and provide a statement 
          about Freedom of Choice. Social Care 
          Navigators should document in the Social 
          Care Plan that Freedom of Choice was 
          verbally provided to the member during 
          the Eligibility Assessment.
        </h3>
      </div>
    </div>
  `
});

const createClinicalCriteriaHTML = (text) => ({
  "type": "html",
  "name": "hClinicalCriteriaHtml",
  "uuid": null,
  "html": `
    <div class="p-4 bg-gray-100 rounded-lg mb-6">
      <h2 class="text-xl font-bold mb-3">Step 7: Confirm Member Meets Eligibility Criteria for Specific HRSN Services, Including Ensuring No Service Duplication</h2>

      <div class="mb-6">
        <h3 class="font-semibold mb-2">7.1 Clinical Conditions from ESMF</h3>
        <p>
          Based on the Enhanced Services Member File (ESMF), the member is identified as having the following Clinical Conditions:
        </p>
      </div>

      <div class="mb-6">
        <h3 class="font-semibold mb-2">7.2. Member Confirmation of Clinical Conditions</h3>
        <h4 class="font-semibold mb-2">How to complete this section:</h4>
        <p class="mb-4">
          In the list below, check off all the clinical criteria listed for the member in the ESMF.
        </p>
        <p class="mb-4">
          Then, review the additional clinical criteria with the member one-by-one and check off any additional criteria they indicate apply to them.
        </p>
        <p>
          The suggested language below provides sample language that can be used to describe each clinical criteria to the member.
        </p>
      </div>

      <div class="space-y-6">
        <div>
          <h3 class="font-semibold mb-2">Suggested Language:</h3>
          <p class="italic">
            "To make sure we understand your health needs and connect you with the right services, I'd like to ask you some
            questions about your health conditions. This information will help us determine which programs and support you
            may be eligible for. Is that okay?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Chronic Conditions</h3>
          <p class="italic">
            "Do you have any ongoing health conditions like diabetes, high blood pressure, heart problems, lung issues
            like COPD or asthma?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Uncontrolled Asthma</h3>
          <p class="italic">
            "Do you have asthma that still causes symptoms or attacks even when you're using your medications?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Enteral or Parenteral Nutrition Therapy</h3>
          <p class="italic">
            "Do you need to get your nutrition through a feeding tube or through an IV into your veins?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Currently in an Institutional Setting</h3>
          <p class="italic">
            "Are you currently staying in a nursing home, rehabilitation center, or hospital?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">
            Heat-Related Illness Requiring ER or UC Visit
          </h3>
          <p class="italic">
            "Have you ever needed emergency medical care because of extreme heat, like heat exhaustion or heat stroke?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">
            Cold-Related Illness Requiring ER or UC Visit
          </h3>
          <p class="italic">
            "Have you ever needed emergency medical care because of extreme cold, like hypothermia or frostbite?"
          </p>
        </div>

        <div>
          <h3 class="font-semibold mb-2">At Risk of Thermoregulation Interference</h3>
          <p class="italic">
            "Do you have any health conditions that make it hard for your body to handle hot or cold temperatures?"
          </p>
        </div>
      </div>
    </div>
  `,
});

const addElementsBefore = (element, elements) => {
  if (element.name === 'qConfirmAccurateInfo') {
    elements.push(createIdentifiedNeedsHTML());
    elements.push(createH1Element('Step 1: Collect Member Consent and Attestation to Complete and Accurate Information'));
    elements.push(createH2Element('1.2 Attestation to Accurate and Complete Information'));
  }

  if (element.name === 'qVerifyIdentity') {
    elements.push(createH1Element(`Step 2: Confirm the Member's identity and their Medicaid Enrollment`, 'hStepTwo'));
    elements.push(createH2Element('2.1 Verification of Member Identity', 'hStepTwo1'));
  }

  if (element.name === 'qProfileFieldsCaptured') {
    elements.push(createH2Element('2.3 Member Demographics and Physical Disabilities'));
  }

  if (element.name === 'qVerifyMedicaidEnrollment') {
    elements.push(createH2Element('2.2 Verification of Medicaid Enrollment', 'hVerificationMedicaidEnrollment'));
  }

  if (element.name === 'qEnhancedPopulations') {
    elements.push(createEnhancedPopulationsHTML());
  }

  if (element.name === 'qTransportationAccess') {
    elements.push(createH1Element('Step 6: Follow-Up Questions for Unmet HRSNs', 'hStepSix'));
    elements.push(createH2Element('Transportation', 'hTransportation'));
  }

  if (element.name === 'qFoodAssistanceType') {
    elements.push(createH2Element('Food', 'hFood'));
  }

  if (element.name === 'qLivingSituation') {
    elements.push(createH2Element('Housing and Utilities', 'hHousingUtilities'));
  }

  if (element.name === 'qSchoolTrainingHelp') {
    elements.push(createH2Element('Education', 'hEducation'));
  }

  if (element.name === 'qEmploymentSituation') {
    elements.push(createH2Element('Employment', 'hEmployment'));
  }

  if (element.name === 'qChildcareHelp') {
    elements.push(createH1Element('Additional Needs', 'hAdditionalNeeds'));
  }

  if (element.name === 'qClinicalCriteria') {
    elements.push(createClinicalCriteriaHTML());
  }

  if (element.name === 'qServiceDuplicationCheck') {
    elements.push(createNYSServiceDuplicationCheckHTML());
  }

  if (element.name === 'qConnectToServices') {
    elements.push(createStepEightHTML());
  }

  if (element.name === 'qNavigatorNotes') {
    elements.push(createConflictOfInterestHTML())
  }
}

const addElementsAfter = (element, elements) => {
  if (element.name === 'qSelectScreening') {
    elements.push(createIdentifiedNeedsHTML());
  }
};

export const createElAssessSurveyJSTemplate = (response, existingAssessment = null) => {
  try {
    const template = {
      configuration: {
        custom: {
          ...response,
        },
        showNavigationButtons: false, // hides the 'next' button at the bottom of the page when there are multiple pages
        title: "Eligibility Assessment V2",
        pages: [
          {
            name: "page1", // outreach page
            elements: []
          },
          {
            name: "page2", // assessment page
            elements: []
          },
        ],
      }
    };

    let n = 0;
    const assessmentScreen = get(existingAssessment, 'data.screen');
    const sortedQuestions = response.questions.sort((a, b) => a.order - b.order);
    const elementsPage1 = [];
    const elementsPage2 = [];
    const questionElementMap = {};
    sortedQuestions.forEach((question, index) => {
      const {
        elementName,
        elementType,
        visibleIf,
        isRequired,
        elementVisible,
        inputType,
        page,
        includeInAnswers,
      } = matchElement(question);

      let choices = question.options?.map((option, j) => {
        return {
          value: option.value.replace(/'/g, ''), // surveyjs element data
          text: option.text, // surveyjs element data
          uuid: option.id, // surveyjs element data
          id: option.id,
          custom: {
            question,
            questionId: question.id,
            elementName: elementName,
            disabled: false,
            option: {
              ...option
            },
          }
        };
      });

      const assessmentQuestion = assessmentScreen?.questions?.find(q => q.id === question.id);
      const selectedChoice = choices && choices.find(c => c.id === assessmentQuestion?.answer?.option_id);
     
      if (!question.options) {
        choices = [];
      }
      const title = DEBUG_MODE ? `${question.primary_text} - ${question.type}` : question.primary_text;
      const element = {
        type: elementType,
        name: elementName,
        inputType,
        min: inputType === SURVEYJS_INPUT_TYPES.NUMBER ? 0 : undefined,
        title,
        visible: elementVisible,
        description: question.instructions || null,
        isRequired,  // TBD
        uuid: question.id,
        id: question.id,
        choices,
        custom: {
          includeInAnswers,
          originalChoices: choices || null,
        }
        // defaultValue: selectedChoice?.value || null,
      };

      questionElementMap[elementName] = question;
      if (page === 1) {
        addElementsBefore(element, elementsPage1);
        elementsPage1.push(element);
        addElementsAfter(element, elementsPage1);
      }
      if (page === 2) {
        addElementsBefore(element, elementsPage2);
        elementsPage2.push(element);
        addElementsAfter(element, elementsPage2);
      }
    });

    template.configuration.pages[0].elements = elementsPage1;
    template.configuration.pages[1].elements = elementsPage2;
    return {
      template,
      questionElementMap,
    };
  } catch (error) {
    console.error('createElAssessSurveyJSTemplate', error);
  }
}

export default {};
